import React, { useEffect, useState } from 'react';
import { imageUrl } from '../../services/imageService';
import type { EnquiryImage } from '../../types/admin';

/**
 * Henvendelsens billeder. Kunden uploader uden at være logget ind og kan
 * derfor ikke hente en visnings-URL — reglerne tillader kun admin at læse.
 * URL'erne hentes derfor her, når en administrator er logget ind.
 */
export function EnquiryImages({
  images
}: {
  images: EnquiryImage[];
}) {
  const [urls, setUrls] = useState<Record<string, string>>({});
  useEffect(() => {
    let active = true;
    const missing = images.filter(image => !image.url && image.path);
    void Promise.all(missing.map(async image => {
      try {
        const url = await imageUrl(image.path);
        return [image.path, url] as const;
      } catch {
        return null;
      }
    })).then(entries => {
      if (!active) return;
      const next: Record<string, string> = {};
      entries.forEach(entry => {
        if (entry) next[entry[0]] = entry[1];
      });
      setUrls(current => ({
        ...current,
        ...next
      }));
    });
    return () => {
      active = false;
    };
  }, [images]);
  if (images.length === 0) return null;
  return <ul className="mt-4 grid grid-cols-3 gap-3 sm:grid-cols-5" data-id="element-201" data-mp="2v93xxobpmikf">
      {images.map(image => {
      const src = image.url || urls[image.path];
      return <li key={image.path} data-id="element-202" data-mp="2r563hqxbxvxp">
            {src ? <a href={src} target="_blank" rel="noreferrer" data-id="element-203" data-mp="23i7neud4gq0b">
                <img src={src} alt={image.name} className="aspect-square w-full rounded-xl object-cover" data-id="element-204" data-mp="1yilayn54bdsk" />
              </a> : <span className="block aspect-square w-full rounded-xl bg-canvas" aria-label={`Henter ${image.name}`} data-id="element-205" data-mp="27irk5wts9rlx" />}
          </li>;
    })}
    </ul>;
}